module.exports = {

  listen: function() {

    var oddElements = document.querySelectorAll(".more-games-span");

    oddElements.forEach(function(element) {
      element.addEventListener("click", function(e) {
        var modalId = element.dataset.modal;
        $('#' + modalId ).modal('show');
      });
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/listeners/more-odds-listener.js
// module id = 2021
// module chunks = 4